import { ajax } from 'jquery'
import { pageId, isMeasurementBookEditUrl } from '../fromPhp'
import { select } from 'd3-selection'
import { addToHTMLList } from './add-to-html-list/addToHTMLList'
import { iconLoading, iconSuccess, iconError } from './icons'
import { onTrashClick } from './onTrashClick'
import { addHint } from '../validation/hint'

/**
 * @param {File} file 
 */
export function uploadFile (file) {
  let fileDiv = addToHTMLList(file.name, '#', null, iconLoading, true)
  ajax({
    type: 'POST',
    url: getUrl(),
    data: getData(file),
    success: pathAndId => onSuccess(fileDiv, pathAndId, file.name),
    error: error => onError(fileDiv, error),
    cache: false,
    contentType: false,
    processData: false
  })
}

export const getUrl = () => {
  // Prefer explicit detection via URL and form action to avoid false negatives
  const path = (window.location && window.location.pathname) ? window.location.pathname : ''
  const form = document.getElementById('page-data-form')
  const action = form && form.getAttribute('action') ? form.getAttribute('action') : ''
  const isMB = isMeasurementBookEditUrl() || /\/measurement-book-pages\/\d+/.test(path) || /\/measurement-book-pages\/\d+/.test(action)
  return isMB
    ? '/measurement-book-pages/' + pageId() + '/uploadFile'
    : '/pages/' + pageId() + '/uploadFile'
}

/**
 * @param {File} file 
 */
function getData (file) {
  let data = new FormData()
  select('#page-data-form')
    .selectAll('input')
    .all(node => {
      let name = node.attr('name')
      if (['_token', '_method'].includes(name)) {
        data.append(name, node.attr('value'))
      }
    })
  data.append('file', file)
  return data
}

/**
 * @param {d3.Selection} fileDiv 
 * @param {Object} pathAndId 
 * @param {number} pathAndId.id
 * @param {string} pathAndId.path
 * @param {string} fileName
 */
function onSuccess (fileDiv, pathAndId, fileName) {
  fileDiv
    .style('border-color', '#17c671')
    .call(a => {
      a.select('a').attr('href', pathAndId.path)
      a.select('i')
        .clas(iconSuccess)
      a.select('.trash')
        .style('visibility', 'visible')
        .onclick(() => onTrashClick(fileDiv, pathAndId.id, fileName))
    })
}

/**
 * @param {d3.Selection} fileDiv 
 * @param {JQuery.jqXHR} error 
 */
function onError (fileDiv, error) {
  fileDiv
    .style('border-color', '#ffb400')
    .call(div => {
      div.select('i')
        .clas(iconError)
      addHint(div.node(), errorText(error), 'right')
    })
}

/**
 * @param {JQuery.jqXHR} error 
 */
const errorText = error =>
  'Fajl nije priložen! ' + (error.responseJSON.errors === undefined ?
    error.responseJSON.message : error.responseJSON.errors.file[0])